import styles from '../../components/sideBar/SideBar.module.scss';

interface IProps {
  selected?: boolean;
  isMobile?: boolean;
}

const Room = ({ selected, isMobile }: IProps) => !isMobile ? (
  <div className={styles.gidIconWrapper}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={29}
    fill="none"
  >
    <circle cx="6.5" cy="3.5" r="2.5" strokeWidth="2" stroke={selected ? '#FAFAFA' : "#888"}/>
    <circle cx="18.5" cy="3.5" r="2.5" strokeWidth="2" stroke={selected ? '#FAFAFA' : "#888"}/>
    <path d="M15 15V27C15 27.5523 15.4477 28 16 28H20.5C21.0523 28 21.5 27.5523 21.5 27V18.5H22.5C23.0523 18.5 23.5 18.0523 23.5 17.5V10.5C23.5 9.94772 23.0523 9.5 22.5 9.5H2C1.44772 9.5 1 9.94772 1 10.5V17.5C1 18.0523 1.44772 18.5 2 18.5H3V27C3 27.5523 3.44772 28 4 28H8.5C9.05228 28 9.5 27.5523 9.5 27V15" strokeWidth="2" strokeLinecap="round" stroke={selected ? '#FAFAFA' : "#888"}/>
  </svg>
  </div>
) : (
  <div className={styles.gidIconWrapper}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={25}
      fill="none"
    >
      <path d="M5.71429 1C6.81887 1 7.71429 1.89544 7.71429 3C7.71429 4.10456 6.81886 5 5.71429 5C4.60973 5 3.7143 4.10456 3.71429 3C3.71429 1.89544 4.60972 1 5.71429 1Z" strokeWidth="2" stroke={selected ? '#FAFAFA' : "#888"}/>
      <path d="M16 1C17.1046 1 18 1.89544 18 3C18 4.10456 17.1046 5 16 5C14.8954 5 14 4.10456 14 3C14 1.89544 14.8954 1 16 1Z" strokeWidth="2" stroke={selected ? '#FAFAFA' : "#888"}/>
      <path d="M13 12.8572V23C13 23.5523 13.4477 24 14 24H17.5714C18.1237 24 18.5714 23.5523 18.5714 23V15.8572H19.2857C19.838 15.8572 20.2857 15.4095 20.2857 14.8572V9.14291C20.2857 8.59062 19.838 8.14291 19.2857 8.14291H1.99999C1.44771 8.14291 0.999992 8.59062 0.999992 9.14291V14.8572C0.999992 15.4095 1.44771 15.8572 1.99999 15.8572H2.71428V23C2.71428 23.5523 3.16199 24 3.71428 24H7.28571C7.83799 24 8.28571 23.5523 8.28571 23V12.8572" strokeWidth="2" strokeLinecap="round" stroke={selected ? '#FAFAFA' : "#888"}/>
    </svg>
  </div>
)
export default Room;
